import { EMPTY_OBJECT } from '../../../constants/common'

export const QA_NAME_MODAL_EXPORT_EMAIL_FILES_CHATS = 'ExportEmailsFilesChats'

export const INITIAL_VALUES = EMPTY_OBJECT

export const EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY = 'ChatsTextOnly'

export const EXPORT_ZIP_FORM_FIELD_CHATS_FILES = 'ChatsFiles'

export const EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE = 'private_chats'

export const EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC = 'public_chats'

export const EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE = 'private_chat_files'

export const EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC = 'public_chat_files'
